module.exports = __webpack_public_path__ + "static/media/gn.d6f23e69.webp";